<script setup lang="ts">
import { ref, unref, watch } from 'vue';

import InputControl from '../input-control.vue';
import InputGroup from '../input-group.vue';

const props = defineProps<{
    search?: boolean;
    filter?: string | null;
    top?: boolean;
}>();

const emit = defineEmits<{
    (event: 'update:filter', value: string): void;
}>();

const filter0 = ref(props.filter ?? '');

function applyFilter() {
    emit('update:filter', unref(filter0));
}

watch(() => props.filter, (val) => {
    filter0.value = val ?? '';
});
</script>
<template>
    <div class="table-nav-menu-mobile table-nav-menu-sticky" :class="props.top ? 'table-nav-menu-sticky-top' : 'table-nav-menu-sticky-child'">
        <slot name="head" />
        <InputGroup v-if="props.search">
            <InputControl
                v-model:model-value="filter0"
                @blur="applyFilter"
                @keydown.enter="applyFilter"
            />
            <template #tail-btn>
                <button
                    type="button"
                    class="btn btn-default"
                    @click.stop="applyFilter"
                >
                    <span class="bi bi-search" />
                </button>
            </template>
        </InputGroup>
        <slot name="tail" />
    </div>
</template>
